import { post } from "../../../js/http";
import storage from "good-storage";
import { getUrlParams, newArr } from "../../../js/util";
import Cookies from "js-cookie";
import { bindPop, verCon } from "../bindPhone/bindPhone";
layui.use(["layer", "form"], function () {
  var $ = layui.jquery,
    layer = layui.layer,
    form = layui.form;
  if (getUrlParams("settingtype") == 2) {
    $($(".setting-nav li")[1])
      .addClass("active")
      .siblings()
      .removeClass("active");
    $($(".setting-content .setting-content-item")[1])
      .addClass("active")
      .siblings()
      .removeClass("active");
  }
  $(".setting-nav li").off("click");
  $(".setting-nav li").click(function () {
    var index = $(this).index();
    $($(".setting-nav li")[index])
      .addClass("active")
      .siblings()
      .removeClass("active");
    $($(".setting-content .setting-content-item")[index])
      .addClass("active")
      .siblings()
      .removeClass("active");
  });

  $("#setTimeBtn").off("click");
  $("#setTimeBtn").click(function () {
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["600px", ""],
      title: "",
      id: "timeRangeCon",
      closeBtn: 2,
      content: $("#setTime-con"),
      end: function () {
        $("#setTime-con").hide();
      },
    });
  });

  // 获取所有input[name=time]
  var flagID = document.querySelectorAll("input[name=time]");
  var aFlagID = new Array();
  for (var j = 0; j < flagID.length; j++) {
    aFlagID.push(flagID[j].id);
  }
  // 监听所有input[name=time]
  for (var i = 0; i < aFlagID.length; i++) {
    form.on("radio(" + aFlagID[i] + ")", function (data) {
      let spans = $(data.elem)
        .parent()
        .parent()
        .find(".integer-con")
        .find("span");
      switch (data.value) {
        case "全天可通话":
          for (var i = 0; i < spans.length; i++) {
            $(spans[i]).addClass("active-this");
          }
          break;
        case "全天不可通话":
          for (var i = 0; i < spans.length; i++) {
            $(spans[i]).removeClass("active-this");
          }
          break;
        case "自定义":
          break;

        default:
          break;
      }
    });
  }

  // 设置接听对象
  $("#setAnswer").off("click");
  $("#setAnswer").click(function () {
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["500px", ""],
      title: "",
      id: "answerCon",
      closeBtn: 2,
      content: $("#answer-con"),
      end: function () {
        $("#answer-con").hide();
      },
    });
    // 设置接听对象
    $("#saveAnswer").off("click");
    $("#saveAnswer").click(function () {
      const answerObj = $("#answer-con")
        .find($("input[type='radio']:checked"))
        .val();
      let postData = {
        UserID: storage.get("userInfo").UserID,
      };
      switch (answerObj) {
        case "不限":
          postData["TallType"] = 0;
          break;
        case "男":
          storage.get("userInfo").Sex == 1
            ? (postData["TallType"] = 3)
            : (postData["TallType"] = 2);
          break;
        case "女":
          storage.get("userInfo").Sex == 2
            ? (postData["TallType"] = 3)
            : (postData["TallType"] = 2);
          break;
        case "关注的用户":
          postData["TallType"] = 1;
          break;
      }
      post(
        "/ApiHome/ApiAction?_ControlName=SetUserTallTypeByPC",
        postData
      ).then((res) => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
  });

  $("#setWinking").off("click");
  $("#setWinking").click(function () {
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["500px", ""],
      title: "",
      id: "winkingCon",
      closeBtn: 2,
      content: $("#winking-con"),
      end: function () {
        $("#winking-con").hide();
      },
    });
    // 付费放电
    $("#setTwinkle").off("click");
    $("#setTwinkle").click(function () {
      const winkingType = $("#winking-form-con")
        .find($("input[type='radio']:checked"))
        .val();
      post("/ApiHome/ApiAction?_ControlName=ActiveOperationByPC", {
        IsEnable: true,
        UseType: winkingType,
      }).then((res) => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
    // 免费放电
    $("#setTFreewinkle").off("click");
    $("#setTFreewinkle").click(function () {
      post("/ApiHome/ApiAction?_ControlName=ActiveOperationByPC", {
        IsEnable: true,
        UseType: 0,
      }).then((res) => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
  });

  $("#setCloseWinking").off("click");
  $("#setCloseWinking").click(function () {
    let closeWinklayer = layer.open({
      type: 1,
      skin: "layer-custom",
      btnAlign: "c",
      area: ["400px", ""],
      title: "",
      closeBtn: 2,
      content: $("#closeWinking-con"),
      end: function () {
        $("#closeWinking-con").hide();
      },
    });
    $("#closeWinking").off("click");
    $("#closeWinking").click(function () {
      post("/ApiHome/ApiAction?_ControlName=ActiveOperationByPC", {
        IsEnable: false,
      }).then((res) => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
    $("#cancelWinking").off("click");
    $("#cancelWinking").click(function () {
      layer.close(closeWinklayer);
    });
  });
  $("#setPsd").off("click");
  $("#setPsd").click(function () {
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["500px", ""],
      title: "",
      id: "newPsdCon",
      closeBtn: 2,
      content: $("#newPsd-con"),
      end: function () {
        $("#newPsd-con").hide();
        $("#newPsd-con")
          .find("input[type=text],select,input[type=hidden]")
          .each(function () {
            $(this).val("");
          });
      },
    });

    // 确认修改
    $("#confirmResetPsd").off("click");
    $("#confirmResetPsd").click(function () {
      if (
        $($(".newPsd")[0]).val().length < 6 ||
        $($(".confirmNewPsd")[0]).val().length < 6
      ) {
        layer.msg("密码由6-16位的数字、字母或字符组成", function () {});
        return;
      }
      if ($($(".newPsd")[0]).val() == $($(".confirmNewPsd")[0]).val()) {
        post("/ApiHome/ApiAction?_ControlName=ChangePasswordByPC", {
          UserID: storage.get("userInfo").UserID,
          OldPassword: $($(".currentPsd")[0]).val(),
          NewPassword: $($(".newPsd")[0]).val(),
        }).then((res) => {
          if (res.ReturnStatus) {
            layer.msg(res.MessageCN, { icon: 1 });
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        });
      } else {
        layer.msg("两次密码不一致", function () {
          //关闭后的操作
        });
      }
    });
  });

  (function inintVerCon() {
    let bindPhoneTemp = require("../bindPhone/bindPhone.art");
    $("#bindPhone-con").html(bindPhoneTemp(storage.get("userInfo")));
    $("#bindPhone").off("click");
    $("#bindPhone").click(function () {
      bindPop();
      verCon();
    });
  })();

  $(".day-con li").off("click");
  $(".day-con li").click(function () {
    var index = $(this).index();
    $($(".day-con li")[index])
      .addClass("active")
      .siblings()
      .removeClass("active");
    $($(".time-con .hours-wrap")[index])
      .addClass("active")
      .siblings()
      .removeClass("active");
  });

  // indexList表示时间段的索引数组，indexStr表示时间段字符串
  let indexList = [],
    indexStr = "";
  $(".integer-con span").off("click");
  $(".integer-con span").click(function () {
    var index = $(this).index();
    var serverTime = [];
    $(this).hasClass("active-this")
      ? $(this).removeClass("active-this")
      : $(this).addClass("active-this");
    let spans = $(this).parent().find("span");
    for (let i = 0; i < spans.length; i++) {
      if ($(spans[i]).hasClass("active-this")) {
        indexList.push(i);
        indexStr = indexList.join(",");
        if (i < 9) {
          serverTime.push("0" + i + ":00-" + "0" + (i + 1) + ":00");
        } else if (i == 9) {
          serverTime.push("09:00-10:00");
        } else if (i > 9) {
          serverTime.push(i + ":00-" + (i + 1) + ":00");
        }
      }
    }
    // console.log(indexList, indexStr);

    // ***************以下是合并时间段的方法暂不需要
    const el = $(this);

    if (serverTime.length == 0) {
      console.log("全天不可通话");
      el.parent()
        .parent()
        .find("input[value='全天不可通话']")
        .prop("checked", true);
      form.render();
    } else if (serverTime.length == 24) {
      console.log("全天可通话");
      el.parent()
        .parent()
        .find("input[value='全天可通话']")
        .prop("checked", true);
      form.render();
    } else {
      console.log("自定义");
      el.parent().parent().find("input[value='自定义']").prop("checked", true);
      form.render();
    }

    // console.log(newArr(serverTime));
    // ***************以上是合并时间段的方法暂不需要
  });

  // 保存时间段
  $("#saveServeT").off("click");
  $("#saveServeT").click(function () {
    let activethisSpans = $(".hours-wrap.active .integer-con span.active-this"),
      indexStr = "";
    for (let i = 0; i < activethisSpans.length; i++) {
      indexStr += $(activethisSpans[i]).attr("data-id") + ",";
    }
    let postData = {
      UserID: storage.get("userInfo").UserID,
      w: $(".day-con li.active").attr("data-day"), //周几
      t: indexStr.substring(0, indexStr.length - 1) || -1, //时段
    };
    saveServeTime(postData);
  });

  // 保存并同步到每天
  $("#synchEveryDay").off("click");
  $("#synchEveryDay").click(function () {
    // 获取值
    let radioVal = $(
      ".hours-con .hours-wrap.active input[name='time']:checked"
    ).val();
    let spans = $(".hours-con .hours-wrap.active .integer-con span");
    let activeSpans = [];
    for (var i = 0; i < spans.length; i++) {
      if ($(spans[i]).hasClass("active-this")) {
        activeSpans.push(i);
      }
    }
    // 设置值
    let allRadio = $(".hours-con .hours-wrap input[name='time']");

    for (var i = 0; i < allRadio.length; i++) {
      if ($(allRadio[i]).val() === radioVal) {
        $(allRadio[i]).prop("checked", true);
      }
    }
    form.render();

    let allIntegerCon = $(".hours-con .hours-wrap .integer-con");
    for (var i = 0; i < allIntegerCon.length; i++) {
      let conSpans = $(allIntegerCon[i]).find("span");
      for (var j = 0; j < conSpans.length; j++) {
        // 清空所有active-this
        $(conSpans[j]).removeClass("active-this");
      }
    }

    for (var i = 0; i < allIntegerCon.length; i++) {
      let conSpans = $(allIntegerCon[i]).find("span");
      for (var j = 0; j < conSpans.length; j++) {
        for (var k = 0; k < activeSpans.length; k++) {
          if (j == activeSpans[k]) {
            $(conSpans[j]).addClass("active-this");
          }
        }
      }
    }
    let activethisSpans = $(".hours-wrap.active .integer-con span.active-this"),
      indexStr = "";
    for (let i = 0; i < activethisSpans.length; i++) {
      indexStr += $(activethisSpans[i]).attr("data-id") + ",";
    }
    let postData = {
      UserID: storage.get("userInfo").UserID,
      w: -1, //周几
      t: indexStr.substring(0, indexStr.length - 1) || -1, //时段
    };
    saveServeTime(postData);
  });
  let quiteLayer;
  $(".setNotDisturb").off("click");
  $(".setNotDisturb").click(function () {
    let postData = {};
    if ($(this).text().trim() === "开启") {
      postData = { IsEnable: true, UserID: storage.get("userInfo").UserID };
      console.log($("#quite-con"));
      quiteLayer = layer.open({
        type: 1,
        skin: "layer-custom",
        btnAlign: "c",
        area: ["400px", ""],
        title: "",
        closeBtn: 2,
        content: $("#quite-con"),
        end: function () {
          $("#quite-con").hide();
        },
      });
      // 确认开启免打扰
      $("#openQuite").click(function () {
        setQuite(postData);
      });
    } else {
      postData = {
        IsEnable: false,
        UserID: storage.get("userInfo").UserID,
      };
      setQuite(postData);
    }

    function setQuite(postData) {
      post(
        "/ApiHome/ApiAction?_ControlName=SetUserIsDisturbByPC",
        postData
      ).then((res) => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          });
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    }
  });
  $(".setStealth").off("click");
  $(".setStealth").click(function () {
    if (storage.get("userInfo").IsVIP) {
      //是VIP
      let postData = {};
      $(this).text().trim() === "开启"
        ? (postData = { IsEnable: true })
        : (postData = { IsEnable: false });
      post("/ApiHome/ApiAction?_ControlName=SetHideBrowseType", postData).then(
        (res) => {
          if (res.ReturnStatus) {
            layer.msg(res.MessageCN, { icon: 1 });
            setTimeout(() => {
              window.location.reload();
            });
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        }
      );
    } else {
      layer.open({
        type: 1,
        skin: "layer-custom",
        area: ["300px", ""],
        title: "",
        id: "privateCon",
        closeBtn: 2,
        content: $("#private-con"),
        end: function () {
          $("#private-con").hide();
        },
      });
    }
  });

  function saveServeTime(data) {
    post("/ApiHome/ApiAction?_ControlName=SetUserServiceTimeByPC", data).then(
      (res) => {
        if (res.ReturnStatus) {
          layer.msg("设置成功", { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          });
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      }
    );
  }
});
